import { render, staticRenderFns } from "./productLi.vue?vue&type=template&id=4b8b4852&scoped=true"
import script from "./productLi.vue?vue&type=script&lang=js"
export * from "./productLi.vue?vue&type=script&lang=js"
import style0 from "./productLi.vue?vue&type=style&index=0&id=4b8b4852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b4852",
  null
  
)

export default component.exports